import type { ProposalDetails } from '@/services/quotes/types';

/**
 * Código do segmento do estipulante (seq. 0) nos detalhes da cotação.
 * Capital Global pode expor o valor em `customer` ou em `customers`.
 */
export function resolveStipulantSegmentCode(
  details: ProposalDetails | undefined
): string {
  if (!details) return '';

  const fromCustomer = (details.customer?.segment ?? '').trim();
  if (fromCustomer) return fromCustomer;

  const customers = details.customers ?? [];
  const stipulant =
    customers.find(c => c.sequenceNumber === 0) ?? customers[0];

  return (stipulant?.segment ?? '').trim();
}
